import React from 'react'

const ShirtTrouser = () => {
  return (
    <div>ShirtTrouser</div>
  )
}

export default ShirtTrouser